import { Suspense } from 'react'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { useSidewall } from '../../../../hooks/state/useSidewall'
import { MarqueeVertical } from '../model/marquee/MarqueeVertical'
import { PlankWall } from '../model/plank/PlankWall'
import { SidewallHighlight } from './SidewallHighlight'
import { SlidingDoor } from './SlidingDoor'
import { useSidewallCamera } from './useSidewallCamera'
import { WallTyp1 } from './WallTyp1'
import { WallTyp2 } from './WallTyp2'
import { Wedge } from './Wedge'
import { Vector3 } from 'three'
import { FrameSlidingDoor } from './FrameSlidingDoor'
import Shutters from './Shutters'

const CameraFocusHelper = ({
  visible = false,
  userHeight,
  spaceBetween,
}: {
  visible?: boolean
  userHeight: number
  spaceBetween: number
}) => {
  return (
    <group position={[0, userHeight / 2, 0]}>
      <mesh visible={visible}>
        <boxGeometry args={[0.1, userHeight, spaceBetween]} />
      </mesh>
    </group>
  )
}

export const SideWall = (): JSX.Element | null => {
  const {
    sideWall,
    windowsWallTyp,
    plankWallWindow,
    type,
    spaceBetween,
    sidewallIndex,
    sidewallId,
    position,
    rotation,
    basicPosition,
    isWallCenter,
    hasSideWall,
  } = useSidewall()

  const { userHeight, isQubus } = useMeasures()

  const name = (type ?? 'type') + (sidewallIndex ?? 0)
  const positionNew = new Vector3(
    basicPosition.x,
    basicPosition.y,
    basicPosition.z
  )

  useSidewallCamera(sidewallId, positionNew, type, name)
  return (
    <group name={name}>
      {hasSideWall && (
        <group position={positionNew} rotation={rotation}>
          <SidewallHighlight />
        </group>
      )}

      <group position={position} rotation={rotation} name={name}>
        <CameraFocusHelper
          visible={false}
          userHeight={userHeight}
          spaceBetween={spaceBetween}
        />

        {!isWallCenter &&
          !isQubus &&
          sideWall.hasWedge &&
          !sideWall.noSelection && <Wedge />}

        {(sideWall.hasSlidingDoor ||
          (sideWall.hasPlankWall && plankWallWindow.hasWindowsWall)) && (
          <SlidingDoor />
        )}

        {sideWall.hasSlidingFrameDoor && <FrameSlidingDoor />}

        {((sideWall.hasWindowsWall && !windowsWallTyp) ||
          (sideWall.hasPlankWall && plankWallWindow.hasTyp1)) && <WallTyp1 />}

        {((sideWall.hasWindowsWall && windowsWallTyp) ||
          (sideWall.hasPlankWall && plankWallWindow.hasTyp2)) && <WallTyp2 />}

        {sideWall.hasPlankWall && (
          <Suspense fallback={null}>
            <PlankWall />
          </Suspense>
        )}

        {sideWall.hasShutters && <Shutters />}

        {sideWall.hasMarquee && <MarqueeVertical />}
      </group>
    </group>
  )
}
